import React, { useState } from "react";
import Loading from "./loading";
import { useNavigate, useParams } from "react-router-dom";
import redirectArray from "./redirectArray";

const ReadyToContinue = ({ readyToContinue, pollMode, uuid, updateQuestions }) => {
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const { courseCode, assessmentCode } = useParams();
    const navigate = useNavigate();

    const handleClick = async (newValue) => {
        if ((readyToContinue && newValue) || (!readyToContinue && !newValue)) {
            return;
        }
        
        if (requestLifeCycle) {
            return;
        }

        try {
            setRequestLifeCycle(true);
            const url = process.env.REACT_APP_EVALUATION_API_URL;
            
            const response = await fetch(url + `/ready-to-continue/${courseCode}/${assessmentCode}/${uuid}`, {
                method: "POST",
                credentials: "include"
            });
            const data = await response.json();
            if (response.status === 200) {
                updateQuestions((prev) => {
                    return prev.map((question) => {
                        if (question.uuid !== uuid) return question;
        
                        return {
                            ...question,
                            readyToContinue: !readyToContinue
                        }
                    })
                });
            } else if (response.status === 404 || response.status === 409) {
                alert(data.detail);
            } else if (response.status in redirectArray) {
                navigate(`/${courseCode}/${assessmentCode}`);
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
            }

        } catch (error) {
            alert("Error: " + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    return (
        <>
            {

                pollMode && (
                    <div className="questions-top-level" style={{ padding: "10px" }}>
                        {
                            requestLifeCycle ?

                            <div className="loading-right-child">
                                <Loading />
                            </div>  

                            :
                            
                            <div className="ready-container">
                                Ready to continue?
                                <div className={`yes-no ${readyToContinue ? "active" : ""}`} onClick={() => handleClick(true)}>
                                    Y
                                </div>
                                <div className={`yes-no ${readyToContinue ? "" : "active"}`} onClick={() => handleClick(false)}>
                                    N
                                </div>
                            </div>
                        }                        
                    </div>
                )
            }
        </>
    );
}

export default ReadyToContinue;